export default "__VITE_ASSET__BkqB4783__"